/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";
import {
  INVENTORY_DELETE,
  INVENTORY_LIST,
  INVENTORY_UPDATE,
} from "../../../../repository/Inventory-repo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { VENDOR_ADD, VENDOR_DELETE, VENDOR_LIST, VENDOR_STATUS_CHANGE, VENDOR_UPDATE } from "../../../../repository/vendorRepo";

const useVendor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
   const [totalCount, setTotalCount] = useState(0);
  const [vendorList, setVendorList] = useState([]);
  const [categoryModal, setCategoryModal] = useState(false);
  const [vendorModal, setVendorModal] = useState(false);
  const [formError, setFormError] = useState({})
  const { id } = useParams(); // Get ID from URL params
  const location = useLocation(); // Get data from navigation state
  const isEditMode = Boolean(id);

  const [filter, setFilter] = useState({
  search: "",
  isDeleted: false, // default to Active
});

  const [openModal, setOpenModal] = useState({
    addVendor: false,
    editVendor: false,
    delete: false,
    data: null,
  });


     const [formDataVendor, setFormDataVendor] = useState({
        name: "",
        address: "",
        gstNumber: "",
  })



    const handleOpenModal = (type, data = null) => {
    setOpenModal((prev) => ({
      ...prev,
      addVendor: type === "add",
      editVendor: type === "edit",
      delete: type === "delete",
      data: data || null,
    }));

   if (type === "edit" && data) {
  setFormDataVendor({
    name: data.name || "",
    address: data.address || "",
    gstNumber: data.gstNumber || "",
    _id: data._id || "",
  });
}
  };

const handleCloseModal = () => {
    setOpenModal({
      addVendor: false,
      editVendor: false,
      delete: false,
      data: null,
    });
    setFormError({});
    setFormDataVendor({})
  };

    const isValid = () => {
    const errorObj = {};
    const {name} = formDataVendor;
    if (!name) errorObj["name"] = "Name is required";
    setFormError(errorObj);
    return Object.keys(errorObj).length === 0;
  };




  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormDataVendor((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setFormError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };


      const handlePagination = (obj) => {
        setController(obj);
    };


    // Initial load - for list page
  useEffect(() => {
    if (!isEditMode) {
      vendorListAPI();
    }

;
  }, []);


    // Trigger API call when pagination changes - for list page
    useEffect(() => {
    if (!isEditMode) {
      vendorListAPI();
    }
  }, [controller.page, controller.rowsPerPage]);


const handleSearchChange = (e) => {
  setFilter((prev) => ({
    ...prev,
    search: e.target.value,
  }));
};


const handleStatusChange = (value) => {
  setFilter((prev) => {
    // if Active (value === 'false') selected, then add isActive: true
    if (value === "false") {
      return { ...prev, isDeleted: value, isActive: true };
    }

    // for All or Deleted, remove isActive completely
    const { isActive, ...rest } = prev;
    return { ...rest, isDeleted: value };
  });
};

const handleApplyFilter = () => {
      // reset to first page
  setController((prev) => ({ ...prev, page: 1 }));

  // use latest filter and page=1
  vendorListAPI({ ...filter, page: 1 });
};

const handleResetFilter = () => {
  const newFilter = { search: "", isDeleted: false, isActive: false };
  setFilter(newFilter);
   setController((prev) => ({ ...prev, page: 1 }));
  vendorListAPI(newFilter); 
};



  const vendorListAPI = async (filterOverride = filter) => {
    try {
      
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        search: filterOverride.search?.trim() || null,
      };

      if (filterOverride.isDeleted === "true") payload.isDeleted = true;
      else if (filterOverride.isDeleted === "false") {
        payload.isActive = true;
        payload.isDeleted = false;
      } 

      setSpinner(true);
      let response = await VENDOR_LIST(payload);
      setVendorList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {
      setVendorList([]);
    }
    setSpinner(false);
  };

    const vendorAdd = async () => {
         if(!isValid()) return;
    try {
      let payload = {
        name: formDataVendor.name,
        address:formDataVendor.address,
        gstNumber:formDataVendor.gstNumber,
      };

      setSpinner(true);
      let response = await VENDOR_ADD(payload);
      if (response.code === 200) {
        toast.success(response.message || "Vendor updated successfully");
        handleCloseModal();
        vendorListAPI();
        setFormDataVendor({});
      } else {
        toast.error(response.message || "Vendor update failed");
      }
    } catch (error) {
      setVendorList([]);
    }
    setSpinner(false);
  };
  
  const vendorUpdate = async () => {
 if(!isValid()) return;
    try {
      let payload = {
           _id: formDataVendor._id,
      name: formDataVendor.name,
      address: formDataVendor.address,
      gstNumber: formDataVendor.gstNumber,
      };

      setSpinner(true);
      let response = await VENDOR_UPDATE(payload);
      if (response.code === 200) {
        toast.success(response.message || "Vendor updated successfully");
        vendorListAPI();
         handleCloseModal();
        setFormDataVendor({});
      } else {
        toast.error(response.message || "Vendor update failed");
      }
    } catch (error) {
      vendorListAPI([]);
    }
    setSpinner(false);
  };

    const vendorDelete = async (id, isDeleted) => {
  
    try {
      let payload = {
        _id:id,
        isDeleted:!isDeleted
      };

      setSpinner(true);
      let response = await VENDOR_DELETE(payload);
      if (response.code === 200) {
        toast.success(response.message ||  (isDeleted ? "Vendor recovered successfully" : "Vendor deleted successfully"));
          const newPage =
    vendorList.length === 1 && controller.page > 1
      ? controller.page - 1
      : controller.page;

  setController((prev) => ({ ...prev, page: newPage }));
        vendorListAPI();
      
      } else {
        toast.error(response.message || "Vendor delete failed");
      }
    } catch (error) {
      vendorListAPI([]);
    }
    setSpinner(false);
  };

const vendorToggleStatusChange = async (id, isActive) => {
  try {
    const payload = {
      _id: id,
      isActive: isActive,
    };

    setSpinner(true);
    const response = await VENDOR_STATUS_CHANGE(payload);

    if (response?.code === 200) {
      toast.success(response?.message || "Status updated successfully");
      await vendorListAPI(); // refresh updated list
    } else {
      toast.error(response?.message || "Failed to update status");
    }
  } catch (error) {
    toast.error("Something went wrong while updating vendor status");
  } finally {
    setSpinner(false);
  }
};

const handleToggleChange = (id, currentStatus) => {
  const newStatus = !currentStatus;
  vendorToggleStatusChange(id, newStatus);
};

  

  return {
    data: {
      spinner,
      vendorModal,
      formDataVendor,
      formError,
      isEditMode,
      controller,
      totalCount,
      vendorList,
      openModal,
      filter,
    },
    methods: {
      handleChange,
      handleOpenModal,
      handleCloseModal,
      vendorUpdate,
      handlePagination,
      vendorAdd,
      vendorDelete,
      handleToggleChange,
    handleSearchChange,
    handleStatusChange,
    handleApplyFilter,
    handleResetFilter,
    },
  };
};

export default useVendor;
